
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/ai-tiktok-video-generator",
      function () {
        return require("private-next-pages/features/ai-tiktok-video-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/ai-tiktok-video-generator"])
      });
    }
  